import { render, staticRenderFns } from "./ActBerdiskusiDaring.vue?vue&type=template&id=2c8d4a35&"
import script from "./ActBerdiskusiDaring.vue?vue&type=script&lang=js&"
export * from "./ActBerdiskusiDaring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports